import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    reference: {
      label: {
        id: 'datasetForm.reference',
        defaultMessage: 'Reference',
        description: 'label of the reference field',
      },
    },
    type: {
      label: {
        id: 'datasetForm.type',
        defaultMessage: 'Type of data',
        description: 'label of the dataset type field',
      },
    },
    firstRowAsColumns: {
      label: {
        id: 'datasetForm.firstRowAsColumns',
        defaultMessage: 'Use first row as column names',
        description: 'label of the dataset firstRowAsColumns field',
      },
    },
    dataset: {
      label: {
        id: 'datasetForm.dataset',
        defaultMessage: 'Dataset',
        description: 'label of the dataset field',
      },
    },
  },
  types: {
    file: {
      label: {
        id: 'datasetForm.types.file',
        defaultMessage: 'File (CSV)',
        description: 'label of the file type',
      },
    },
    spreadsheet: {
      label: {
        id: 'datasetForm.types.spreadsheet',
        defaultMessage: 'Spreadsheet',
        description: 'label of the spreadsheet type',
      },
    },
    existingDataset: {
      label: {
        id: 'datasetForm.types.existingDataset',
        defaultMessage: 'Existing dataset',
        description: 'label of the existing dataset type',
      },
    },
  },
  loadingMessage: {
    id: 'datasetForm.loadingMessage',
    defaultMessage: 'Attaching data',
    description: 'Loading message of the dataset form',
  },
};

export default defineMessages(translations);
